import ColaboradorService from "services/ColaboradorService";
import { useState } from "react";
import { useContext } from "react";
import { SecurityContext } from "context/SecurityContextProvider";

const useListarResponsables = () => {
  const [filtroResponsable, setFiltroResponsable] = useState(undefined);
  const {getUsuarioAutenticado} = useContext(SecurityContext);
  const cargarResponsables = async (valor) => {   
    const respuesta = await ColaboradorService.listarPorNombreCompletoODni({ filtro: valor.trim(),login:getUsuarioAutenticado().login });
    const responsables = respuesta.colaboradores.map((colaborador) => ({
      label: colaborador.nombreCompleto,
      value: colaborador.numeroDocumentoIdentidad,
    }));
    responsables.unshift({ label: "TRABAJADOR", value: "TRABAJADOR" });
    return responsables;
  };

  return { filtroResponsable, setFiltroResponsable, cargarResponsables };
};
export default useListarResponsables;
